import { FC } from 'react';
import { CustomerCatalogueContainer } from '../CustomerCatalogueContainer';
import CreateBundle from './CreateBundle';

export const CustomerCreateBundlePage: FC = () => {
  return (
    <CustomerCatalogueContainer>
      <CreateBundle />
    </CustomerCatalogueContainer>
  );
};
